module.exports = __webpack_public_path__ + "static/media/riskIndicator2.8394e883.svg";